"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "+1 24579 54581" | "Info@example.com" */
    linkText: ReactNode;
    /** Detected variants: "tel:+12456589856" | "mailto:contact@example.com" */
    href: string;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Contact Us" | "Hospitals" | "Specialities" | "Clinics" */
    link0Text: ReactNode;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeElevenFooterSectionGeneratedProps = {
    footerDiv0Div0Div0ClassName?: string;
    footerDiv0Div0Div0Div0Div0Div0Form0FormVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Form0FormProps?: Partial<ComponentProps<"form">>;
    footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    footerDiv0Div0Div0Div0Div0Div0Form0Input0InputPlaceholder?: string;
    /** Default: "ENHANCE BEAUTY, BOOST CONFIDENCE, START TODAY!" */
    footerDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    footerDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    footerDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Company" */
    footerDiv0Div0Div0Div1Div0H30H3Text?: ReactNode;
    footerDiv0Div0Div0Div1Div0H30H3Visible?: boolean;
    footerDiv0Div0Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Call / Email" */
    footerDiv0Div0Div0Div2Div0Div0H40H4Text?: ReactNode;
    footerDiv0Div0Div0Div2Div0Div0H40H4Visible?: boolean;
    footerDiv0Div0Div0Div2Div0Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "Our Address" */
    footerDiv0Div0Div0Div2Div0Div1H40H4Text?: ReactNode;
    footerDiv0Div0Div0Div2Div0Div1H40H4Visible?: boolean;
    footerDiv0Div0Div0Div2Div0Div1H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0Div1H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "8432 Mante Highway, Aminaport, USA" */
    footerDiv0Div0Div0Div2Div0Div1P0PText?: ReactNode;
    /** Default: "Contact" */
    footerDiv0Div0Div0Div2Div0H30H3Text?: ReactNode;
    footerDiv0Div0Div0Div2Div0H30H3Visible?: boolean;
    footerDiv0Div0Div0Div2Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    footerDiv1Div0Div0ClassName?: string;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv1Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Doccure" */
    footerDiv1Div0Div0Div1Div0Div0DivDataText?: string;
    /** Default: "Doccure" */
    footerDiv1Div0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "footer" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-3.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-4.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer" */
    footerImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-5.png" */
    footerImageWithBasePath2ImageSrc?: string;
    footerImageWithBasePath2ImageVisible?: boolean;
    footerImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerSectionUls2LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionDivs: FooterSectionDivsItem[];
    footerSectionUls2: FooterSectionUls2Item[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSectionDivsItemWrapper?: (item: FooterSectionDivsItem, content: ReactNode) => ReactNode;
    footerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkVisible?: boolean;
    footerSectionDivsLinkRenderer?: (item: FooterSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkVisible?: boolean;
    footerSectionUls2LinkRenderer?: (item: FooterSectionUls2Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeElevenFooterSectionGenerated: FC<HomeElevenFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div0Div0Div0Form0Input0InputPlaceholder = "Enter Email Address",
    footerDiv0Div0Div0Div0Div0H20H2Text = "ENHANCE BEAUTY, BOOST CONFIDENCE, START TODAY!",
    footerDiv0Div0Div0Div0Div0H20H2Visible,
    footerDiv0Div0Div0Div0Div0H20H2Renderer,
    footerDiv0Div0Div0Div0Div0H20H2Props,
    footerDiv0Div0Div0Div1Div0H30H3Text = "Company",
    footerDiv0Div0Div0Div1Div0H30H3Visible,
    footerDiv0Div0Div0Div1Div0H30H3Renderer,
    footerDiv0Div0Div0Div1Div0H30H3Props,
    footerDiv0Div0Div0Div2Div0Div0H40H4Text = "Call / Email",
    footerDiv0Div0Div0Div2Div0Div0H40H4Visible,
    footerDiv0Div0Div0Div2Div0Div0H40H4Renderer,
    footerDiv0Div0Div0Div2Div0Div0H40H4Props,
    footerDiv0Div0Div0Div2Div0Div1H40H4Text = "Our Address",
    footerDiv0Div0Div0Div2Div0Div1H40H4Visible,
    footerDiv0Div0Div0Div2Div0Div1H40H4Renderer,
    footerDiv0Div0Div0Div2Div0Div1H40H4Props,
    footerDiv0Div0Div0Div2Div0Div1P0PText = "8432 Mante Highway, Aminaport, USA",
    footerDiv0Div0Div0Div2Div0H30H3Text = "Contact",
    footerDiv0Div0Div0Div2Div0H30H3Visible,
    footerDiv0Div0Div0Div2Div0H30H3Renderer,
    footerDiv0Div0Div0Div2Div0H30H3Props,
    footerDiv1Div0Div0Div0Div0DivText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerDiv1Div0Div0Div1Div0Div0DivDataText = "Doccure",
    footerDiv1Div0Div0Div1Div0Div0DivText = "Doccure",
    footerImageWithBasePath0ImageAlt = "footer",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-bg-3.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "footer",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-bg-4.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    footerImageWithBasePath2ImageAlt = "footer",
    footerImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/footer-bg-5.png",
    footerImageWithBasePath2ImageVisible,
    footerImageWithBasePath2ImageRenderer,
    footerImageWithBasePath2ImageProps,
    footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonVisible,
    footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonRenderer,
    footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonProps,
    footerDiv0Div0Div0Div0Div0Div0Form0FormVisible,
    footerDiv0Div0Div0Div0Div0Div0Form0FormRenderer,
    footerDiv0Div0Div0Div0Div0Div0Form0FormProps,
    footerSectionUls2LiLink0LinkProps,
    liLink0LinkProps,
    linkLinkProps,
    footerDiv0Div0Div0ClassName,
    footerDiv1Div0Div0ClassName,
    footerSectionDivs,
    footerSectionUls2,
    footerSectionUls,
    footerSectionDivsItemWrapper,
    footerSectionDivsRenderer,
    footerSectionDivsLinkVisible,
    footerSectionDivsLinkRenderer,
    footerSectionDivsLinkProps,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionUls2LinkVisible,
    footerSectionUls2LinkRenderer,
    footerSectionUls2LinkProps,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer-eleven footer">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-md-5 g-4"}>
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="footer-widget footer-about">
                                {renderNode(footerDiv0Div0Div0Div0Div0H20H2Visible, footerDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="title-main" {...(footerDiv0Div0Div0Div0Div0H20H2Props ?? {})}>{footerDiv0Div0Div0Div0Div0H20H2Text}</h2>
                                ))}
                                <div className="subscribe-input">
                                    {renderNode(footerDiv0Div0Div0Div0Div0Div0Form0FormVisible, footerDiv0Div0Div0Div0Div0Div0Form0FormRenderer, (
                                        <form action="#" {...(footerDiv0Div0Div0Div0Div0Div0Form0FormProps ?? {})}>
                                            <input type="email" className="form-control" placeholder={footerDiv0Div0Div0Div0Div0Div0Form0Input0InputPlaceholder} />
                                            {renderNode(footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonVisible, footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonRenderer, (
                                                <button type="submit" className="btn-icon btn btn-secondary" {...(footerDiv0Div0Div0Div0Div0Div0Form0Button0ButtonProps ?? {})}>
                                                    <i className="isax isax-arrow-right-1" />
                                                </button>
                                            ))}
                                        </form>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-sm-6">
                            <div className="footer-widget">
                                {renderNode(footerDiv0Div0Div0Div1Div0H30H3Visible, footerDiv0Div0Div0Div1Div0H30H3Renderer, (
                                    <h3 className="footer-title" {...(footerDiv0Div0Div0Div1Div0H30H3Props ?? {})}>{footerDiv0Div0Div0Div1Div0H30H3Text}</h3>
                                ))}
                                <ul className="footer-menu">
                                    {renderCollectionNode(
                                        footerSectionUls,
                                        (item: FooterSectionUlsItem) => (
                                            <li key={item.key}>
                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </li>
                                        ),
                                        footerSectionUlsItemWrapper,
                                        footerSectionUlsRenderer
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-sm-6">
                            <div className="footer-widget">
                                {renderNode(footerDiv0Div0Div0Div2Div0H30H3Visible, footerDiv0Div0Div0Div2Div0H30H3Renderer, (
                                    <h3 className="footer-title" {...(footerDiv0Div0Div0Div2Div0H30H3Props ?? {})}>{footerDiv0Div0Div0Div2Div0H30H3Text}</h3>
                                ))}
                                <div className="footer-support">
                                    {renderNode(footerDiv0Div0Div0Div2Div0Div0H40H4Visible, footerDiv0Div0Div0Div2Div0Div0H40H4Renderer, (
                                        <h4 className="support-title" {...(footerDiv0Div0Div0Div2Div0Div0H40H4Props ?? {})}>{footerDiv0Div0Div0Div2Div0Div0H40H4Text}</h4>
                                    ))}
                                    {renderCollectionNode(
                                        footerSectionDivs,
                                        (item: FooterSectionDivsItem) => (
                                            renderItemNode(footerSectionDivsLinkVisible, footerSectionDivsLinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof footerSectionDivsLinkProps === "function" ? footerSectionDivsLinkProps(item) : (footerSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>{item.linkText}</SmartLink>
                                            ))
                                        ),
                                        footerSectionDivsItemWrapper,
                                        footerSectionDivsRenderer
                                    )}
                                </div>
                                <div className="footer-support">
                                    {renderNode(footerDiv0Div0Div0Div2Div0Div1H40H4Visible, footerDiv0Div0Div0Div2Div0Div1H40H4Renderer, (
                                        <h4 className="support-title" {...(footerDiv0Div0Div0Div2Div0Div1H40H4Props ?? {})}>{footerDiv0Div0Div0Div2Div0Div1H40H4Text}</h4>
                                    ))}
                                    <p>{footerDiv0Div0Div0Div2Div0Div1P0PText}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className={footerDiv1Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-lg-5">
                            <ul className="social-icon">
                                {renderCollectionNode(
                                    footerSectionUls2,
                                    (item: FooterSectionUls2Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls2LinkVisible, footerSectionUls2LinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUls2LinkProps === "function" ? footerSectionUls2LinkProps(item) : (footerSectionUls2LinkProps ?? {}))} {...(typeof footerSectionUls2LiLink0LinkProps === "function" ? footerSectionUls2LiLink0LinkProps(item) : (footerSectionUls2LiLink0LinkProps ?? {}))}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls2ItemWrapper,
                                    footerSectionUls2Renderer
                                )}
                            </ul>
                            <div className="copy-right">{footerDiv1Div0Div0Div0Div0DivText}</div>
                        </div>
                        <div className="col-lg-7">
                            <div className="animate-refelect-text">
                                <div className="animate-text" data-text={footerDiv1Div0Div0Div1Div0Div0DivDataText}>{footerDiv1Div0Div0Div1Div0Div0DivText}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid shadow-1" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid shadow-2" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath2ImageVisible, footerImageWithBasePath2ImageRenderer, (
                <SmartImage src={footerImageWithBasePath2ImageSrc} alt={footerImageWithBasePath2ImageAlt} className="img-fluid shadow-3" {...(footerImageWithBasePath2ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeElevenFooterSectionGenerated;
